import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuUserExtraFeaturesService } from '@app/core/services/au-user-extra-features.service';
import { TranslateService } from '@tolgee/ngx';
import config from '@app/configs/au-main-config';

/**
 * Guard that prevents access to view-related features when the user's organization
 * doesn't have the Views feature enabled.
 *
 * Redirects to an error page when access is denied.
 */
export function viewsEnabledGuard(): boolean {
	const auUserExtraFeaturesService = inject(AuUserExtraFeaturesService);
	const router = inject(Router);
	const translateService = inject(TranslateService);

	if (!auUserExtraFeaturesService.isViewsEnabled()) {
		router.navigate([config.auRoutes.errorPage.link], {
			state: {
				title: translateService.instant('views_unavailable'),
				descriptionFirstLine: translateService.instant('views_not_enabled_description'),
				descriptionSecondLine: translateService.instant(
					'contact_administrator_for_feature'
				),
				descriptionThirdLine: '',
			},
		});
		return false;
	}

	return true;
}
